'use client';

import dynamic from 'next/dynamic';
import React, { useCallback, useState } from 'react';

import { Sheet } from '@zoomit/mobile-sheet';
import type { CategoryType, GroupedCategoryType } from '@zoomit/web-kit';

import { NavbarWithClose } from '../Navbar';

const CategoryList = dynamic(() => import('../../category/CategoryList').then((res) => res.CategoryList));

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const CategorySheet = (props: Props) => {
  const { isOpen, onClose } = props;
  const [path, setPath] = useState('');

  const handleClick = (item: CategoryType | GroupedCategoryType) => {
    if ('categoryItems' in item) {
      setPath(item.slug);
      return;
    }
    setPath('');
    onClose();
  };

  const handleBack = useCallback(() => {
    if (path !== '') {
      setPath('');
      return;
    }
    onClose();
  }, [path, onClose]);

  const handleClose = () => {
    setPath('');
    onClose();
  };

  return (
    <Sheet isOpen={isOpen} onClose={handleClose}>
      <Sheet.Container isFullScreen>
        <Sheet.Header>
          <NavbarWithClose onClose={handleClose} onBack={path === '' ? undefined : handleBack} />
        </Sheet.Header>
        <Sheet.Content>
          <CategoryList path={path} onItemClick={handleClick} />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};

export default React.memo(CategorySheet);
